export default __webpack_public_path__ + "static/media/instagram.8642ec73.svg";